// export const ADD_TO_CART_REQUEST = 'ADD_TO_CART_REQUEST';
// export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
// export const ADD_TO_CART_FAILURE = 'ADD_TO_CART_FAILURE';

// export const UPDATE_CART_QUANTITY_REQUEST = 'UPDATE_CART_QUANTITY_REQUEST';
// export const UPDATE_CART_QUANTITY_SUCCESS = 'UPDATE_CART_QUANTITY_SUCCESS';
// export const UPDATE_CART_QUANTITY_FAILURE = 'UPDATE_CART_QUANTITY_FAILURE';

// export const REMOVE_FROM_CART_REQUEST = 'REMOVE_FROM_CART_REQUEST';
// export const REMOVE_FROM_CART_SUCCESS = 'REMOVE_FROM_CART_SUCCESS';
// export const REMOVE_FROM_CART_FAILURE = 'REMOVE_FROM_CART_FAILURE';

// export const SET_SALE_ID = 'SET_SALE_ID';
// export const CLEAR_SALE_ID = 'CLEAR_SALE_ID';

// export const SYNC_CART_WITH_SERVER_REQUEST = 'SYNC_CART_WITH_SERVER_REQUEST';
// export const SYNC_CART_WITH_SERVER_SUCCESS = 'SYNC_CART_WITH_SERVER_SUCCESS';
// export const SYNC_CART_WITH_SERVER_FAILURE = 'SYNC_CART_WITH_SERVER_FAILURE';

// // Existing constants remain the same
// export const ADD_TO_CART = 'ADD_TO_CART';
// export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
// export const UPDATE_QUANTITY = 'UPDATE_QUANTITY';
// export const CLEAR_CART = 'CLEAR_CART';
// export const APPLY_DISCOUNT = 'APPLY_DISCOUNT';
// export const ADD_TAB = 'ADD_TAB';
// export const REMOVE_TAB = 'REMOVE_TAB';
// export const SWITCH_TAB = 'SWITCH_TAB';
// export const RENAME_TAB = 'RENAME_TAB';
  

// export const HOLD_SALE_REQUEST = 'HOLD_SALE_REQUEST';
// export const HOLD_SALE_SUCCESS = 'HOLD_SALE_SUCCESS';
// export const HOLD_SALE_FAILURE = 'HOLD_SALE_FAILURE';
// export const SET_HOLD_STATUS = 'SET_HOLD_STATUS';


// export const RESUME_SALE_REQUEST = 'RESUME_SALE_REQUEST';
// export const RESUME_SALE_SUCCESS = 'RESUME_SALE_SUCCESS';
// export const RESUME_SALE_FAILURE = 'RESUME_SALE_FAILURE';




export const ADD_TO_CART_REQUEST = 'ADD_TO_CART_REQUEST';
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_FAILURE = 'ADD_TO_CART_FAILURE';

export const UPDATE_CART_QUANTITY_REQUEST = 'UPDATE_CART_QUANTITY_REQUEST';
export const UPDATE_CART_QUANTITY_SUCCESS = 'UPDATE_CART_QUANTITY_SUCCESS';
export const UPDATE_CART_QUANTITY_FAILURE = 'UPDATE_CART_QUANTITY_FAILURE';

export const REMOVE_FROM_CART_REQUEST = 'REMOVE_FROM_CART_REQUEST';
export const REMOVE_FROM_CART_SUCCESS = 'REMOVE_FROM_CART_SUCCESS';
export const REMOVE_FROM_CART_FAILURE = 'REMOVE_FROM_CART_FAILURE';

export const SET_SALE_ID = 'SET_SALE_ID';
export const CLEAR_SALE_ID = 'CLEAR_SALE_ID';

export const SYNC_CART_WITH_SERVER_REQUEST = 'SYNC_CART_WITH_SERVER_REQUEST';
export const SYNC_CART_WITH_SERVER_SUCCESS = 'SYNC_CART_WITH_SERVER_SUCCESS';
export const SYNC_CART_WITH_SERVER_FAILURE = 'SYNC_CART_WITH_SERVER_FAILURE';

export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const UPDATE_QUANTITY = 'UPDATE_QUANTITY';
export const CLEAR_CART = 'CLEAR_CART';
export const APPLY_DISCOUNT = 'APPLY_DISCOUNT';
export const ADD_TAB = 'ADD_TAB';
export const REMOVE_TAB = 'REMOVE_TAB';
export const SWITCH_TAB = 'SWITCH_TAB';
export const RENAME_TAB = 'RENAME_TAB';

export const HOLD_SALE_REQUEST = 'HOLD_SALE_REQUEST';
export const HOLD_SALE_SUCCESS = 'HOLD_SALE_SUCCESS';
export const HOLD_SALE_FAILURE = 'HOLD_SALE_FAILURE';
export const SET_HOLD_STATUS = 'SET_HOLD_STATUS';

export const RESUME_SALE_REQUEST = 'RESUME_SALE_REQUEST';
export const RESUME_SALE_SUCCESS = 'RESUME_SALE_SUCCESS';
export const RESUME_SALE_FAILURE = 'RESUME_SALE_FAILURE';
